import React, { useRef, useEffect, useState } from 'react';
import * as d3 from 'd3';

const D3PieChart = ({ data }) => {
  const svgRef = useRef(null);
  const tooltipRef = useRef(null);
  const [svgWidth, getSvgWidth] = useState();

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth
    });
  };
  useEffect(() => {
    window.addEventListener('resize', setDimension);

    return () => {
      window.removeEventListener('resize', setDimension);
    };
  }, [screenSize]);

  useEffect(() => {
    setTimeout(() => {
      getSvgWidth(svgRef?.current?.offsetWidth);
    }, 100);
  }, [screenSize]);

  useEffect(() => {
    if (data && data.length > 0) {
      const values = data.flatMap((item) => item.values);
      //const container = d3.select(svgRef.current);
      //const width = container.node().getBoundingClientRect().width || svgWidth;

      const width = 400;
      const height = 400;
      const margin = 40;
      const radius = Math.min(width, height) / 2 - margin;

      const svg = d3
        .select(svgRef.current)
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

      const color = d3.scaleOrdinal(d3.schemeCategory10).range(
        d3.schemeCategory10.map((c) => d3.rgb(c).brighter(0.4))
      );

      const pie = d3
        .pie()
        .value((d) => d.value)
        .sort(null);

      const arc = d3.arc().outerRadius(radius).innerRadius(0);

      const pieData = pie(values);

      svg
        .selectAll('path')
        .data(pieData)
        .enter()
        .append('path')
        .attr('d', arc)
        .attr('fill', (d, i) => color(i))
        .on('mouseover', (event, d) => 
          {
          const percentage = ((
            d.value 
            / d3.sum(values, (v) => v.value)) * 100).toFixed(
            2
          );
          const key = d.data.key;
          const val = d.value;
          tooltipRef.current.style.display = 'block';
          tooltipRef.current.innerHTML = `${key}: ${val}`;

          const [x, y] = d3.pointer(event);
          tooltipRef.current.style.transform = `translate(${x + 200}px, ${y - 200}px)`;
        })
        .on('mouseout', () => {
          tooltipRef.current.style.display = 'none';
        });

      svg
        .selectAll('text')
        .data(pieData)
        .enter()
        .append('text')
        .attr('transform', (d) => `translate(${arc.centroid(d)})`)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .style('font-size', '14px')
        .style('fill', 'white')
        .style('font-weight', 'bold')
        .style(
          'visibility',
          (d) => `${d.endAngle - d.startAngle > 0.2 ? 'visible' : 'hidden'}`
        )
        .text((d) => `${((d.value / d3.sum(values, (v) => v.value)) * 100).toFixed(2)}%`);

      // legend container
      const legend = d3
        .select('#legend-container')
        .style('display', 'flex')
        .style('flex-wrap', 'wrap');

      legend
        .selectAll('.legend-item')
        .data(pieData)
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('margin', '5px 5px')
        .html((d, i) => {
          return `
            <div style="width: 20px; height: 20px; background-color: ${color(
              i
            )}; margin-right: 10px;"></div>
            <span>${d.data.key}</span>
          `;
        });
    }
  }, [data, svgWidth]);

  return (
    <div>
      <svg ref={svgRef}></svg>

      <div
        ref={tooltipRef}
        style={{
          position: 'absolute',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          padding: '5px',
          borderRadius: '5px',
          pointerEvents: 'none',
          display: 'none',
          zIndex: 10
        }}
      ></div>

      <div id="legend-container" style={{ marginTop: '20px', fontSize: '14px' }}></div>
    </div>
  );
};

export default D3PieChart;
